import { render } from "./AddOffered.vue?vue&type=template&id=b09b11e2&ts=true"
import script from "./AddOffered.vue?vue&type=script&lang=ts"
export * from "./AddOffered.vue?vue&type=script&lang=ts"

import "./AddOffered.vue?vue&type=style&index=0&id=b09b11e2&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__